import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  ARIA_ATTRIBUTES_TYPES = {
    expanded: { type: Boolean },
  }

  static values = {
    attributes: Array
  }

  connect() {
    useClickOutside(this)
  }

  toggle() {
    this.attributesValue.forEach((attribute) => {
      const attributeConfig = this.ARIA_ATTRIBUTES_TYPES[attribute]
      if (!attributeConfig) {
        console.error(`Unsupported attribute: ${attribute}`)
        return
      }

      switch (attributeConfig.type) {
        case Boolean:
          this.toggleBoolean(attribute)
          break
      }
    })
  }

  toggleBoolean(attribute) {
    const target = this.#target
    if (!target) return

    const value = target.getAttribute("aria-" + attribute)

    target.setAttribute(
      'aria-' + attribute,
      value === 'true' ? 'false' : 'true'
    )
  }

  clickOutside() {
    this.#target?.setAttribute('aria-expanded', 'false')
  }

  // The state lives on the interactive trigger, not on the non-interactive
  // wrapper, so that aria-expanded stays valid. The trigger is always the first
  // child; components that declare aria-haspopup expose it there, while custom
  // triggers (a button slotted into the dropdown) fall back to the first
  // interactive element within it. We only ever look inside the trigger, never
  // the menu, so aria-expanded can't land on a menu item — and if the slot
  // holds no interactive element we set nothing, since aria-expanded on a
  // plain wrapper is invalid (WCAG 4.1.2 / axe aria-allowed-attr).
  get #target() {
    const trigger = this.element.firstElementChild
    if (!trigger) return null

    const selector = '[aria-haspopup], button, [role="button"], a[href]'
    return trigger.matches(selector) ? trigger : trigger.querySelector(selector)
  }
}
